import React, { useState, useContext } from "react";
import { useLocation, useNavigate, NavLink } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
// Importa jwtDecode como named export, conforme o pacote atual
import { jwtDecode } from "jwt-decode";
import {
  IconCalendarPlus,
  IconHome,
  IconDeviceCctv,
  IconChecklist,
  IconReport,
  IconSchool,
  IconUsers,
  IconBuildingWarehouse,
  IconMail,
  IconBuilding,
  IconCoins,
} from "@tabler/icons-react";
import logoFMS from "../logo-fms.png";
import RequireGroup from "./RequireGroup";

function AdminLayout({ children }) {
  const { user: contextUser, logoutUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const [openDropdowns, setOpenDropdowns] = useState({});

  const location = useLocation();
  const isMonitoramentoActive = location.pathname.startsWith("/monitoramento");
  const isAgendaActive = location.pathname.startsWith("/agendas");

  // Tenta obter o usuário do contexto; se não houver, decodifica o token salvo no localStorage
  let user = contextUser;
  if (!user) {
    const tokenString = localStorage.getItem("authTokens");
    if (tokenString) {
      try {
        const tokens = JSON.parse(tokenString);
        if (tokens.access) {
          user = jwtDecode(tokens.access);
        }
      } catch (error) {
        console.error("Erro ao decodificar o token:", error);
      }
    }
  }

  const handleLogout = () => {
    logoutUser();
    navigate("/login");
  };

  const toggleDropdown = (name) => {
    setOpenDropdowns((prevState) => ({
      ...prevState,
      [name]: !prevState[name],
    }));
  };

  return (
    <div className="page">
      {/* Sidebar */}
      <aside className="navbar navbar-vertical navbar-expand-lg navbar-dark bg-dark">
        <div className="container-fluid">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#sidebar-menu"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <NavLink to="/" className="navbar-brand navbar-brand-autodark">
            <img src={logoFMS} alt="Logo" style={{ height: "4rem" }} />
          </NavLink>
          <div className="navbar-nav flex-row d-lg-none"></div>
          <div className="collapse navbar-collapse" id="sidebar-menu">
            <ul className="navbar-nav pt-lg-3">
              <li className="nav-item">
                <NavLink to="/" className="nav-link">
                  <span className="nav-link-icon d-md-none d-lg-inline-block">
                    <IconHome className="icon" />
                  </span>
                  <span className="nav-link-title">Home</span>
                </NavLink>
              </li>
              <RequireGroup group={['tecnica', 'admin']}>
                <li className={`nav-item dropdown ${isAgendaActive || openDropdowns["agenda"] ? "show" : ""}`}>
                  <a
                    href="#"
                    className={`nav-link dropdown-toggle ${isAgendaActive ? "active" : ""}`}
                    onClick={(e) => {
                      e.preventDefault();
                      toggleDropdown("agenda");
                    }}
                  >
                    <span className="nav-link-icon d-md-none d-lg-inline-block">
                      <IconCalendarPlus className="icon" />
                    </span>
                    <span className="nav-link-title">Agendas</span>
                  </a>
                  <div className={`dropdown-menu ${isAgendaActive || openDropdowns["agenda"] ? "show" : ""}`}>
                    <NavLink
                      to="/agendas/novo"
                      className={({ isActive }) => "dropdown-item" + (isActive ? " active" : "")}
                    >
                      Cadastrar Agenda
                    </NavLink>
                    <NavLink
                      to="/agendas/"
                      end
                      className={({ isActive }) => "dropdown-item" + (isActive ? " active" : "")}
                    >
                      Todas as Agendas
                    </NavLink>
                  </div>
                </li>
              </RequireGroup>

              <RequireGroup group={['tecnica', 'admin']}>
                <li className={`nav-item dropdown ${ isMonitoramentoActive || openDropdowns["monitoramento"] ? "show" : "" }`}>
                  <a
                    href="#"
                    className={`nav-link dropdown-toggle ${isMonitoramentoActive ? "active" : ""}`}
                    onClick={(e) => {
                      e.preventDefault();
                      toggleDropdown("monitoramento");
                    }}
                  >
                    <span className="nav-link-icon d-md-none d-lg-inline-block">
                      <IconDeviceCctv className="icon" />
                    </span>
                    <span className="nav-link-title">Monitoramento</span>
                  </a>
                  <div className={`dropdown-menu ${ isMonitoramentoActive || openDropdowns["monitoramento"] ? "show" : "" }`}>
                    <NavLink 
                      to="/monitoramento"
                      end
                      className={({ isActive }) => "dropdown-item" + (isActive ? " active" : "")}
                    >
                      Edital
                    </NavLink>
                    <NavLink 
                      to="/monitoramento/mensal/"
                      className={({ isActive }) => "dropdown-item" + (isActive ? " active" : "")}
                    >
                      Mensal
                    </NavLink>
                  </div>
                </li>
              </RequireGroup>

              <RequireGroup group={['tecnica', 'admin']}>
                <li className="nav-item">
                  <NavLink to="/instituicoes" className="nav-link">
                    <span className="nav-link-icon d-md-none d-lg-inline-block">
                      <IconSchool className="icon" />
                    </span>
                    <span className="nav-link-title">Instituições</span>
                  </NavLink>
                </li>
              </RequireGroup>

              <RequireGroup group={['admin']}>
                <li className="nav-item">
                  <NavLink to="/gestor" className="nav-link">
                    <span className="nav-link-icon d-md-none d-lg-inline-block">
                      <IconUsers className="icon" />
                    </span>
                    <span className="nav-link-title">Gestores</span>
                  </NavLink>
                </li>
              </RequireGroup>
              
              <RequireGroup group={['cartasvisitas', 'admin']}>
                <li className="nav-item">
                  <NavLink to="/cartas" className="nav-link">
                    <span className="nav-link-icon d-md-none d-lg-inline-block">
                      <IconMail className="icon" />
                    </span>
                    <span className="nav-link-title">Cartas</span>
                  </NavLink>
                </li>
              </RequireGroup>

              <RequireGroup group={['cartasvisitas', 'admin']}>
                <li className="nav-item">
                  <NavLink to="/visitas" className="nav-link">
                    <span className="nav-link-icon d-md-none d-lg-inline-block">
                      <IconChecklist className="icon" />
                    </span>
                    <span className="nav-link-title">Visitas</span>
                  </NavLink>
                </li>
              </RequireGroup>

              <RequireGroup group={['estoque', 'estoque_ver', 'estoque_admin', 'admin']}>
                <li className="nav-item">
                  <NavLink to="/estoque" className="nav-link">
                    <span className="nav-link-icon d-md-none d-lg-inline-block">
                      <IconBuildingWarehouse className="icon" />
                    </span>
                    <span className="nav-link-title">Estoque</span>
                  </NavLink>
                </li>
              </RequireGroup>

              <RequireGroup group={['estoque_admin', 'admin']}>
                <li className="nav-item">
                  <NavLink to="/patrimonio" className="nav-link disabled">
                    <span className="nav-link-icon d-md-none d-lg-inline-block">
                      <IconBuilding className="icon" />
                    </span>
                    <span className="nav-link-title">Patrimônio</span>
                  </NavLink>
                </li>
              </RequireGroup>

              <RequireGroup group={['admin']}>
                <li className="nav-item">
                  <NavLink to="/financeiro" className="nav-link disabled">
                    <span className="nav-link-icon d-md-none d-lg-inline-block">
                      <IconCoins className="icon" />
                    </span>
                    <span className="nav-link-title">Financeiro</span>
                  </NavLink>
                </li>
              </RequireGroup>

              <RequireGroup group={['admin']}>
                <li className="nav-item">
                  <NavLink to="/relatorios" className="nav-link">
                    <span className="nav-link-icon d-md-none d-lg-inline-block">
                      <IconReport className="icon" />
                    </span>
                    <span className="nav-link-title">Relatórios</span>
                  </NavLink>
                </li>
              </RequireGroup>
            </ul>
          </div>
        </div>
      </aside>

      {/* Conteúdo Principal */}
      <div className="page-wrapper">
      {/* Header */}
        <header
          className="navbar navbar-light bg-light header"
          style={{
            paddingTop: "0px",
            paddingBottom: "0px",
            color: "#6c7a91",
          }}
        >
          <div className="container-fluid d-flex justify-content-between align-items-center">
            {/* Espaço para logo ou título à esquerda, se necessário */}
            <div className="navbar-brand">
              {/* Pode adicionar logo ou título aqui */}
            </div>
            
            {/* Área direita com notificações e usuário */}
            <div className="d-flex align-items-center">
              {/* Dropdown de notificações - visível apenas em MD+ */}
              <div className="nav-item dropdown d-none d-md-flex me-3">
                <a href="#" className="nav-link px-0" data-bs-toggle="dropdown" tabIndex="-1" aria-label="Show notifications">
                  {/* SVG ícone sino (notificações) */}
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-1">
                    <path d="M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"></path>
                    <path d="M9 17v1a3 3 0 0 0 6 0v-1"></path>
                  </svg>
                  <span className="badge bg-red"></span>
                </a>
                <div className="dropdown-menu dropdown-menu-arrow dropdown-menu-end dropdown-menu-card">
                  <div className="card">
                    <div className="card-header">
                      <h3 className="card-title">Ultimas Atualizações</h3>
                    </div>
                    <div className="list-group list-group-flush list-group-hoverable">
                      <div className="list-group-item">
                        <div className="row align-items-center">
                          <div className="col-auto"><span className="status-dot status-dot-animated bg-red d-block"></span></div>
                          <div className="col text-truncate">
                            <a href="#" className="text-body d-block">Exemplo 1</a>
                            <div className="d-block text-secondary text-truncate mt-n1">Change deprecated html tags to text decoration classes (#29604)</div>
                          </div>
                          <div className="col-auto">
                            <a href="#" className="list-group-item-actions">
                              {/* SVG ícone estrela */}
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon text-muted icon-2">
                                <path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"></path>
                              </svg>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="list-group-item">
                        <div className="row align-items-center">
                          <div className="col-auto"><span className="status-dot d-block"></span></div>
                          <div className="col text-truncate">
                            <a href="#" className="text-body d-block">Exemplo 2</a>
                            <div className="d-block text-secondary text-truncate mt-n1">justify-content:between ⇒ justify-content:space-between (#29734)</div>
                          </div>
                          <div className="col-auto">
                            <a href="#" className="list-group-item-actions show">
                              {/* SVG ícone estrela - amarela */}
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon text-yellow icon-2">
                                <path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"></path>
                              </svg>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="list-group-item">
                        <div className="row align-items-center">
                          <div className="col-auto"><span className="status-dot d-block"></span></div>
                          <div className="col text-truncate">
                            <a href="#" className="text-body d-block">Exemplo 3</a>
                            <div className="d-block text-secondary text-truncate mt-n1">Update change-version.js (#29736)</div>
                          </div>
                          <div className="col-auto">
                            <a href="#" className="list-group-item-actions">
                              {/* SVG ícone estrela */}
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon text-muted icon-2">
                                <path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"></path>
                              </svg>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="list-group-item">
                        <div className="row align-items-center">
                          <div className="col-auto"><span className="status-dot status-dot-animated bg-green d-block"></span></div>
                          <div className="col text-truncate">
                            <a href="#" className="text-body d-block">Exemplo 4</a>
                            <div className="d-block text-secondary text-truncate mt-n1">Regenerate package-lock.json (#29730)</div>
                          </div>
                          <div className="col-auto">
                            <a href="#" className="list-group-item-actions">
                              {/* SVG ícone estrela */}
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon text-muted icon-2">
                                <path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"></path>
                              </svg>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            
              {/* Dropdown de usuário posicionado à direita */}
              <div className="nav-item dropdown">
                <a 
                  href="#" 
                  className="nav-link d-flex lh-1 p-0 px-2" 
                  data-bs-toggle="dropdown" 
                  aria-label="Open user menu" 
                  aria-expanded="false"
                >
                  <span 
                    className="avatar avatar-sm" 
                    style={{backgroundImage: user && user.avatar ? `url(${user.avatar})` : "url(./static/avatars/000m.jpg)"}}
                  ></span>
                  <div className="d-none d-xl-block ps-2">
                    <div>
                      {user
                        ? `${user.first_name} ${user.last_name}`
                        : "Usuário"}
                    </div>
                    <div className="mt-1 small text-secondary">
                      {user && user.role ? user.role : "Usuário"}
                    </div>
                  </div>
                </a>
                <div className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                  <a href="#" className="dropdown-item">Perfil</a>
                  <a href="#" className="dropdown-item">Feedback</a>
                  <div className="dropdown-divider"></div>
                  <a href="#" className="dropdown-item">Configurações</a>
                  <a 
                    href="#" 
                    onClick={handleLogout} 
                    className="dropdown-item"
                  >
                    Sair
                  </a>
                </div>
              </div>
            </div>
          </div>
        </header>

        {/* Conteúdo da Página */}
        <div className="page-body">
          <div className="container-xl">{children}</div>
        </div>

        {/* Footer */}
        <footer className="footer footer-transparent">
          <div className="container-xl">
            <small>© 2025 - Tacacode</small>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default AdminLayout;